import { useNavigate } from "react-router-dom";
import { Wallet, Car, Building2, RefreshCcw, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

const PRODUCTS = [
  {
    icon: Wallet,
    title: "Personal",
    range: "$1k – $50k",
    term: "12 – 60 mo",
    body: "Consolidate, renovate, celebrate — one flat rate, no collateral, no awkward family loans.",
  },
  {
    icon: Car,
    title: "Auto",
    range: "$5k – $75k",
    term: "24 – 72 mo",
    body: "Pre-approval before you walk onto the lot. Negotiate like a cash buyer, drive home the same day.",
  },
  {
    icon: Building2,
    title: "Business",
    range: "$10k – $150k",
    term: "12 – 60 mo",
    body: "Working capital in days, not board meetings. Reviewed on revenue, not just your credit score.",
  },
  {
    icon: RefreshCcw,
    title: "Debt consolidation",
    range: "$2k – $40k",
    term: "12 – 60 mo",
    body: "Roll your cards into one payment and watch the robot hunt down your interest rate.",
  },
];

const Products = () => {
  const navigate = useNavigate();
  return (
    <section id="products" data-testid="products" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <p className="label-mono text-[#007AFF] mb-4">Loan products</p>
            <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-[#0A1628] text-4xl md:text-6xl">
              One robot,<br />every kind of money.
            </h2>
          </div>
          <button
            data-testid="products-cta"
            onClick={() => navigate("/apply")}
            className="group inline-flex items-center gap-2 rounded-full border border-black/10 px-6 py-3 text-sm font-semibold text-[#0A1628] transition-all duration-300 hover:border-black/25 hover:-translate-y-0.5"
          >
            Compare my options <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.07} className="h-full">
              <article
                data-testid={`product-card-${i}`}
                className="h-full flex flex-col rounded-3xl border border-black/5 bg-white p-8 shadow-[0_8px_32px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_48px_rgba(0,122,255,0.14)] hover:border-[#007AFF]/30"
              >
                <div className="flex items-center justify-between">
                  <span className="label-mono text-[#52525B]">0{i + 1}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#007AFF]/8 text-[#007AFF]">
                    <p.icon className="w-5 h-5" />
                  </span>
                </div>
                <h3 className="mt-8 font-display text-2xl font-bold text-[#0A1628]">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#52525B] flex-1">{p.body}</p>
                <div className="mt-8 pt-5 border-t border-black/5 flex items-center justify-between">
                  <span className="mono text-xs text-[#0A1628]">{p.range}</span>
                  <span className="mono text-xs text-[#52525B]">{p.term}</span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
